export const FETCH_GENRES_SUCCESS = 'FETCH_GENRES_SUCCESS';
export const FETCH_GENRES_FAILED = 'FETCH_GENRES_FAILED';
export const FETCH_PLAYLIST_CAT_SUCCESS = 'FETCH_PLAYLIST_CAT_SUCCESS';
export const FETCH_PLAYLIST_CAT_FAILED = 'FETCH_PLAYLIST_CAT_FAILED';
export const FETCH_GEOS_SUCCESS = 'FETCH_GEOS_SUCCESS';
export const FETCH_GEOS_FAILED = 'FETCH_GEOS_FAILED';
export const FETCH_STOCK_MUSIC_SUCCESS = 'FETCH_STOCK_MUSIC_SUCCESS';
export const FETCH_STOCK_MUSIC_FAILED = 'FETCH_STOCK_MUSIC_FAILED';
export const FETCH_STOCK_MUSIC_REQUESTED = 'FETCH_STOCK_MUSIC_REQUESTED';

export function fetchGenresSuccess(genres) {
  return {
    type: FETCH_GENRES_SUCCESS,
    genres,
  };
}

export function fetchGenresFailed(err) {
  return {
    type: FETCH_GENRES_FAILED,
    err,
  };
}

export function fetchPlaylistCategoriesSuccess(categories) {
  return {
    type: FETCH_PLAYLIST_CAT_SUCCESS,
    categories,
  };
}

export function fetchPlaylistCategoriesFailed(err) {
  return {
    type: FETCH_PLAYLIST_CAT_FAILED,
    err,
  };
}

export function fetchGeosSuccess(geos) {
  return {
    type: FETCH_GEOS_SUCCESS,
    geos,
  };
}

export function fetchGeosFailed(err) {
  return {
    type: FETCH_GEOS_FAILED,
    err,
  };
}

export function fetchStockMusic() {
  return {
    type: FETCH_STOCK_MUSIC_REQUESTED,
  };
}

export function fetchStockMusicSuccess(tracks) {
  return {
    type: FETCH_STOCK_MUSIC_SUCCESS,
    tracks,
  };
}

export function fetchStockMusicFailed(err) {
  return {
    type: FETCH_STOCK_MUSIC_FAILED,
    err,
  };
}



// WEBPACK FOOTER //
// ./src/actions/targeting.js